import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import green from '@material-ui/core/colors/green';


const True = () => <CheckCircleIcon style={{ color: green[500] }} />;

export default True;
